import * as types from './column.types';
import * as constants from './column.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const columnReducer = generateResourceReducer<types.IColumn>({
  STORE: constants.STORE_COLUMN,
  CLEAR: constants.CLEAR_COLUMN,
});
